@if(errorCode() === '403'){
  <nav>
    <div class="sign-out-container">
      <dpqa-button class="btn-logout" iconName="log-out" iconSize="1.6" [padding]="[1.2, 1, 1.2, 1]" [fontSize]="1.4"
        type="default" (click)="handleLogout()">
        {{ "COMMON.SIGN_OUT" | translate }}
      </dpqa-button>
    </div>
  </nav>
}

<div class="error-page">
  <div class="error-page-container">
    <dpqa-icon-alert [iconName]="errorIcon()" [iconSize]="7.7"
      [alertMessage]="'COMMON.ERRORS.' + errorCode() + '.TITLE' | translate"
      [alertDescription]="'COMMON.ERRORS.' + errorCode() + '.DESCRIPTION' | translate" [type]="'error'" />

    @if(showTenantSelection()){
      <dpqa-button data-testid="switch-tenant-button" routerLink="/tenant/selection" type="primary">
        {{ "COMMON.SWITCH_TENANT" | translate }}
      </dpqa-button>
    }
    @if(homeRoute$ | async; as homeRoute) {
      @if(homeRoute.link && homeRoute.name) {
        <dpqa-button data-testid="go-to-first-route-button" [routerLink]="homeRoute.link" replaceUrl type="primary">
          {{ 'GOTO.' + homeRoute.name | translate }}
        </dpqa-button>
      }
    }
    <!-- TODO refactor to use loadingQueueService in 1.3 -->
    @if(!(homeRoute$ | async)) {
      <dpqa-loading-spinner />
    }
  </div>
</div>
